import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions, Response} from '@angular/http';
import {Message} from 'primeng/components/common/api';
import {calcProjectFileAndBasePath} from "@angular/compiler-cli";
import {Organization} from "../views/setting/organization/organization";
import {Favorites} from "../model/favorites";

@Injectable()
export class SharedService {

    title: string;
    routeButtons: any[];
    routeBtmButtons: any[];
    trans_status: any;
    msgs: Message[] = [];
    itemShow: any;
    modelName = '';
    itemService: any;
    columns: any[];
    RowID:any;
    systemscreens: any[] = [];
    item:any;

  constructor(private http: Http) {
  }
    setTitle(newValue: string) {
        this.title = newValue;
    }

    getTitle() {
        return this.title;
    }

    setItem(item:any) {
      this.item = item;
    }

    getItem() {
    return this.item;
    }

    getSystemScreens(){
    }

    setTransStatus(status:any){
        this.trans_status = this.item.trans_status;
    }

    setButtons(buttons: any[]) {
        this.routeButtons = [
            {label: 'Add', icon: 'fa-plus', btnClass: 'btn-info', btnId: 'addButton'},
            {label: 'Edit', icon: 'fa-edit', btnClass: 'btn-warning', btnId: 'saveButton'},
            {label: 'Search', icon: 'fa-search', btnClass: 'btn-primary', btnId: ''},
            {label: 'Undo', icon: 'fa-undo', btnClass: 'btn-inverse', btnId: ''},
            {label: 'Print', icon: 'fa-print', btnClass: 'btn-skype', btnId: ''},
            {label: 'Export Excel', icon: 'fa-file-excel-o', btnClass: 'btn-instagram', btnId: ''},
            {label: 'Delete', icon: 'fa-trash', btnClass: 'btn-danger', btnId: ''},
            {label: 'Save', icon: 'fa-save', btnClass: 'btn-success', btnId: ''},

        ];
        this.routeButtons = buttons;
    }

    setBtmButtons(buttons: any[]) {
        this.routeBtmButtons = [
            {label: 'Add', icon: 'fa-plus', btnClass: 'btn-info', btnId: 'addBtmButton'},
            {label: 'Edit', icon: 'fa-edit', btnClass: 'btn-warning', btnId: 'saveBtmButton'},
            {label: 'Search', icon: 'fa-search', btnClass: 'btn-primary', btnId: 'searchBtmButton'},
            {label: 'Search', icon: 'fa-search', btnClass: 'btn-primary', btnId: 'archiveBtmButton'},
            {label: 'Undo', icon: 'fa-undo', btnClass: 'btn-inverse', btnId: 'undoBtmButton'},
            {label: 'Print', icon: 'fa-print', btnClass: 'btn-skype', btnId: ''},
            {label: 'Export Excel', icon: 'fa-file-excel-o', btnClass: 'btn-instagram', btnId: ''},
            {label: 'Delete', icon: 'fa-trash', btnClass: 'btn-danger', btnId: ''},
            {label: 'Save', icon: 'fa-save', btnClass: 'btn-success', btnId: ''},
            {label: 'Record data', icon: '', btnClass: 'btn-info', btnId: 'recordButton'},
            {label: 'Undo Editing', icon: 'fa-undo', btnClass: 'btn-inverse', btnId: 'undoButton'},
            {label: 'Items Recovery', icon: 'fa-undo', btnClass: 'btn-inverse', btnId: 'itemsButton'},
        ];
        this.routeBtmButtons = buttons;
    }

    getTransStatus() {

      if(this.item && this.item.trans_status)
        return this.item.trans_status;
      else
        return;
    }

    getButtons() {
        return this.routeButtons;
    }

    getBtmButtons() {
        return this.routeBtmButtons;
    }

    setItemShow(itemShow: any) {
        this.itemShow = itemShow;
    }

    getItemShow() {
        return this.itemShow;
    }

    setModelName(name: string) {
        this.modelName = name;
    }

    getModelName() {
        return this.modelName;
    }

    setItemService(itemService: any) {
        this.itemService = itemService;
        // console.log(this.itemService);
    }


    getItemService() {
        // console.log(this.itemService);
        return this.itemService;

    }

    setColumns(columns: any[]) {
        this.columns = columns;
        // console.log(this.itemService);
    }

    getColums() {
        //console.log(this.itemService);
        return this.columns;

    }
    setScreen(favorite: Favorites) {
        // return this.http.post('favorites', favorite).map((response: Response) => response.json());
        return this.http.post('favorites' , favorite).map((response: Response) => response.json());

    }
    systemScreen(){
      const system = localStorage.getItem('OpenSystem');
      return this.http.get('menu/'+system).map((response: Response) => response.json());
    }
    getSearchTemplate(screen:string) {
      const params = new URLSearchParams();
      params.set('screen',screen);
      return this.http.get('search?'+ params.toString()).map((response: Response) => response.json());
    }
    getAllFav(id) {
        return this.http.get('fav/all/'+ id).map((response: Response) => response.json());
    }
    getAllFavor() {
        return this.http.get('favor/all').map((response: Response) => response.json());
    }
    saveSearchTemplate(object:any) {
      return this.http.post('search',object).map((response: Response) => response.json());
    }

    saveHomePage(url:string) {
      return this.http.post('user/sethome',{url:url}).map((response: Response) => response.json());
    }

    getfileshow(_id: string) {
      return this.http.get('files/image/' + _id).map((response: Response) => response.json());
    }
}



// WEBPACK FOOTER //
// ./src/app/services/SharedService.service.ts